import { createSlice } from '@reduxjs/toolkit';
import { post } from 'api/fetch';

// ================== Reducers ================== //

const slice = createSlice({
  name: 'nomad_insurance/offers',
  initialState: {
    isLoading: false,
    error: null,
    publicOffer: null,
    personalOffer: null
  },
  reducers: {
    // fetchPublicOffer
    fetchPublicOfferRequest: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    fetchPublicOfferSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.error = null;
      state.publicOffer = payload;
    },
    fetchPublicOfferFailure: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
      state.publicOffer = null;
    },
    // fetchPersonalOffer
    fetchPersonalOfferRequest: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    fetchPersonalOfferSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.error = null;
      state.personalOffer = payload;
    },
    fetchPersonalOfferFailure: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
      state.personalOffer = null;
    }
  }
});

export default slice.reducer;

// ================== Actions ================== //

const { actions } = slice;

export const fetchPublicOffer = (body) => async (dispatch) => {
  dispatch(actions.fetchPublicOfferRequest());

  try {
    const response = await post(`/public/offers`, body, {
      isNIOrchestrator: true
    });

    dispatch(actions.fetchPublicOfferSuccess(response));
  } catch (error) {
    dispatch(actions.fetchPublicOfferFailure(error));
  }
};

export const fetchPersonalOffer =
  (age, addons, startDate, endDate, deductible, independenceOffers = true) =>
  async (dispatch) => {
    dispatch(actions.fetchPersonalOfferRequest());

    try {
      const body = {
        age,
        startDate,
        endDate,
        addons,
        deductible
      };
      const response = await post(
        `/offers/v3?independenceOffers=${independenceOffers}`,
        body,
        { isNIOrchestrator: true }
      );

      dispatch(actions.fetchPersonalOfferSuccess(response));
    } catch (error) {
      dispatch(actions.fetchPersonalOfferFailure(error));
    }
  };
